'use client';

import {
  Highlight as NativeHighlight,
  HighlightProps as NativeHighlightProps,
  alpha,
} from '@mantine/core';
import { palette } from '@ui-kit/colors';

type HighlightProps = NativeHighlightProps;

function Highlight({ children, ...props }: HighlightProps) {
  return (
    <NativeHighlight
      highlightStyles={(theme) => ({
        backgroundColor: alpha(palette.blackroomBlue, 0.15),
      })}
      {...props}
    >
      {children}
    </NativeHighlight>
  );
}

export default Highlight;
